import RestCrudThunks from './restCrudThunksGenerator';
import { ROLE_TYPES } from '../utils/DataConstants';
import { CONTRACTORS_CRUD_ACTION_CREATORS } from '../actions/contractors_private_network_actions';
import FetchUtils, { parseJSON } from './fetch_utils';
import { getBackendUri } from '../utils/EnvConfigUtils';
import { logoutSuccess } from '../actions/session_actions';

const fetchUtils = new FetchUtils();
const baseUrl = getBackendUri();

// private_network/supplier_supplier_relationships
export const ContractorPrivateNetworksRestCrudThunksForBuyer = new RestCrudThunks(
	'supplier_supplier_relationships',
	'supplier_supplier_relationships',
	'supplier_supplier_relationships',
	'supplier_supplier_relationships',
	CONTRACTORS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.BUYER,
	false,
	'private_network/'
);
export const ContractorPrivateNetworksRestCrudThunksForSupplier = new RestCrudThunks(
	'supplier_supplier_relationships',
	'supplier_supplier_relationships',
	'supplier_supplier_relationships',
	'supplier_supplier_relationships',
	CONTRACTORS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'private_network/'
);

export const deleteSupplierSupplierRelationshipBySupplierFacilityId =
	(roleType) => (supplierFacilityId) => {
		const apiUrl = `/api/v1/${roleType}/private_network/supplier_supplier_relationships/delete_by_supplier/${supplierFacilityId}`;
		return (dispatch) => {
			return new Promise((resolve, reject) => {
				fetchUtils
					.delete(baseUrl + apiUrl, {
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
					})
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (status === 401) {
							dispatch(logoutSuccess());
						}
						if (d.status === 'error') {
							reject(d.message);
						} else {
							resolve(d.data);
						}
					})
					.catch((d) => {
						reject(d.message);
					});
			});
		};
	};
